import { dxtToLocalServerTime, ErrorModal } from "@dexteel/mesf-core";
import { Card, CardContent } from "@mui/material";
import ReactECharts from "echarts-for-react";
import { useMemo, useState } from "react";
import { BilletData } from "../models/OverviewResponse";

export const BilletChart = ({ billetData }: { billetData: BilletData[] }) => {
	const [error, setError] = useState("");

	const processedData = useMemo(() => {
		if (!billetData || billetData.length === 0) {
			return {
				timeLabels: [],
				totalBillets: [],
				normalBillets: [],
				cobbleBillets: [],
			};
		}

		const timeLabels = billetData.map((item) => {
			return dxtToLocalServerTime(item.IntervalStart, "HH:mm");
		});

		const totalBillets = billetData.map((item) => item.BilletCount);
		const normalBillets = billetData.map((item) => item.NormalBillets);
		const cobbleBillets = billetData.map((item) => item.CobbleBillets);

		return {
			timeLabels,
			totalBillets,
			normalBillets,
			cobbleBillets,
		};
	}, [billetData]);

	const option = {
		title: {
			text: "Production over last 3 hours",
			left: "center",
			textStyle: {
				fontSize: 12,
				fontWeight: "bold",
			},
		},
		xAxis: {
			type: "category",
			data: processedData.timeLabels,
			axisLabel: {
				fontSize: 10,
				interval: Math.floor(processedData.timeLabels.length / 8),
			},
		},
		yAxis: {
			type: "value",
			min: 0,
			axisLabel: {
				fontSize: 10,
			},
		},
		tooltip: {
			confineToContainer: false,
			trigger: "axis",
			formatter: function (params: any) {
				let result = `Time: ${params[0].name}<br/>`;
				params.forEach((param: any) => {
					result +=
						param.marker +
						" " +
						param.seriesName +
						": " +
						param.value +
						" billets<br/>";
				});
				return result;
			},
			textStyle: {
				fontSize: 11,
			},
		},
		legend: {
			show: false,
			top: 0,
			textStyle: {
				fontSize: 10,
			},
		},
		series: [
			{
				name: "Total Billets",
				data: processedData.totalBillets,
				type: "line",
				smooth: true,
				symbol: "circle",
				symbolSize: 3,
				itemStyle: {
					color: "#2196F3",
				},
				lineStyle: {
					color: "#2196F3",
					width: 2,
				},
			},
		],
		grid: {
			top: 30,
			left: 15,
			right: 15,
			bottom: 40,
			containLabel: true,
		},
	};

	return (
		<>
			<Card
				sx={{
					height: "8rem",
					overflow: "visible",
				}}
				elevation={1}
			>
				<CardContent
					sx={{
						padding: "2px",
						width: "100%",
					}}
				>
					<ReactECharts
						option={option}
						style={{ height: "9rem", width: 450 }}
					/>
				</CardContent>
			</Card>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
